import React, { useEffect, useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { formatAmount, getAllMonths, getAllYears, getFieldData } from "../../Services/appService";
import GeneratePdf from "../../app/components/Report/GeneratePdf";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getFilterAllCandidates, loadCandidatesByFilter } from "../../app/store/candidate";
import { getMonthlyPayCandidates, loadMonthlyPayCandidates } from "../../app/store/report";
import { getPartnerAllCandidate, loadPartnerAllCandidate } from "../../app/store/partner";

const CUSTOM_REPORT_STYLES = {
  shell: {
    background: "linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)",
    border: "1px solid rgba(203, 213, 225, 0.9)",
    borderRadius: "20px",
    boxShadow: "0 16px 40px rgba(15, 23, 42, 0.06)",
    overflow: "hidden"
  },
  hero: {
    padding: "20px 22px 16px 22px",
    background: "linear-gradient(135deg, #eff6ff 0%, #f8fafc 55%, #ffffff 100%)",
    borderBottom: "1px solid rgba(203, 213, 225, 0.75)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    flexWrap: "wrap"
  },
  heroCopy: {
    flex: "1 1 420px",
    minWidth: "280px"
  },
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px"
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "15px",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    minWidth: 0
  },
  eyebrow: {
    display: "inline-block",
    marginBottom: "8px",
    color: "#2563eb",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase"
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 800,
    lineHeight: 1.25
  },
  subtitle: {
    margin: 0,
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.5,
    maxWidth: "760px"
  },
  actionRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end"
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    padding: "18px 22px 0 22px"
  },
  statCard: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    backgroundColor: "#ffffff",
    padding: "16px",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)"
  },
  statLabel: {
    margin: 0,
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  statValue: {
    margin: "10px 0 6px 0",
    color: "#0f172a",
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: 1
  },
  statMeta: {
    margin: 0,
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.5
  },
  contentWrap: {
    padding: "18px 22px 0px 22px"
  },
  filterShell: {
    borderRadius: "18px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    padding: "16px",
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)"
  },
  filterGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px"
  },
  filterLabel: {
    display: "block",
    marginBottom: "8px",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em"
  },
  sectionTitle: {
    margin: "0 0 6px 0",
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 700
  },
  sectionSubtitle: {
    margin: "0 0 18px 0",
    color: "#64748b",
    fontSize: "13px"
  },
  tableShell: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  table: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  tableCell: {
    verticalAlign: "middle",
    padding: "18px 16px",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff"
  },
  totalCell: {
    verticalAlign: "middle",
    padding: "18px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fafc",
    color: "#0f172a",
    fontWeight: 800
  },
  emptyState: {
    padding: "42px 24px",
    textAlign: "center",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "26px"
  },
  emptyTitle: {
    margin: 0,
    color: "#0f172a",
    fontSize: "18px",
    fontWeight: 700
  },
  emptyText: {
    margin: "10px auto 0 auto",
    color: "#64748b",
    fontSize: "14px",
    lineHeight: 1.6
  }
};

const CustomReport = () => {

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedYear, setSelectedYear] = useState("");
  const [candidateList, setCandidateList] = useState([]);
  const [monthlyRpt, setMonthlyRpt] = useState([]);
  const [allRpts, setAllRpts] = useState([]);
  const [pdfShowHide, setPdfShowHide] = useState(false);
  const [selectedCol, setSelectedCol] = useState([]);
  const [selectedColData, setSelectedColData] = useState([]);
  const [userDetails, setUserDeatils] = useState([]);
  const [candidateObj, setcandidateObj] = useState(null);
  const [candidateEntity, setCandidateEntity] = useState(null);

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const filterAllCandidatesSelector = useSelector(getFilterAllCandidates);
  const monthlyPayCandidatesSelector = useSelector(getMonthlyPayCandidates);
  const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);

  const usrType = localStorage.getItem("userType");

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    if (!userDetailsSelector)
      dispatch(loadUserDetails(usrId));
  }, []);

  useEffect(() => {
    if (userDetailsSelector) {
      setUserDeatils(userDetailsSelector);
      if (usrType === "candidate")
        getCandidateDetails(currentUser.id);
      else if (userDetailsSelector?.approved > 0)
        dispatch(loadPartnerAllCandidate(userDetailsSelector.partnerid, 0))
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setCandidateList(partnerAllCandidateSelector);
  }, [partnerAllCandidateSelector])



  const getCandidateDetails = (id) => {
    const frmBody = new FormData();
    frmBody.append("id", id);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadCandidatesByFilter(frmBody))
  };

  useEffect(() => {
    if (filterAllCandidatesSelector.length > 0) {
      const candidate = filterAllCandidatesSelector[0];

      setcandidateObj(candidate);

      const entityType = getFieldData(
        candidate.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );

      let rptType = "candidate";
      if (entityType === "C2C Basis") rptType = "subcontractor";
      if (userDetails?.partnerType === "Recruiter") rptType = "recruiter";

      setCandidateEntity(entityType)
      dispatch(loadMonthlyPayCandidates(candidate.id, rptType))

    }
  }, [filterAllCandidatesSelector]);

  useEffect(() => {
    if (monthlyPayCandidatesSelector.length > 0) {

      setAllRpts(monthlyPayCandidatesSelector);

      let filterRpt = monthlyPayCandidatesSelector;
      if (selectedYear !== "")
        filterRpt = filterRpt.filter((x) => x.year === parseInt(selectedYear));

      setMonthlyRpt(filterRpt);
    }
  }, [monthlyPayCandidatesSelector])

  const handleCandidateChange = ({ currentTarget }) => {
    setMonthlyRpt([]);
    setAllRpts([]);
    setSelectedYear("");
    if (currentTarget.value !== "")
      getCandidateDetails(currentTarget.value);
  };

  const handleChangeYear = ({ currentTarget }) => {
    if (currentTarget.value !== "") {
      const rtps = allRpts.filter(
        (x) => x.year === parseInt(currentTarget.value)
      );
      setMonthlyRpt(rtps);
      setSelectedYear(currentTarget.value);
    } else {
      setMonthlyRpt(allRpts);
      setSelectedYear("");
    }
  };

  const getTotalRows = () => {
    let hrs = 0;
    let min = 0;
    let invAmt = 0;
    let payAmt = 0;
    let adPlusAmt = 0;
    let adMinAmt = 0;
    let adpAmt = 0;

    monthlyRpt.forEach((item) => {
      hrs += Number(item.hours) || 0;
      min += Number(item.minutes) || 0;
      invAmt += Number(item.totalAmount) || 0;
      payAmt += Number(item.paidAmount) || 0;
      adPlusAmt += Number(item.adjustPlus) || 0;
      adMinAmt += Number(item.adjustMinus) || 0;
      adpAmt += Number(item.adpDeduction) || 0;
    });

    // ⏱ Normalize minutes (convert 60+ minutes -> hours)
    hrs += Math.floor(min / 60);
    min = min % 60;

    // Determine user type
    const isCandidate = usrType === "candidate";
    const isW2 = isCandidate && candidateEntity === "W2 Basis";
    const is1099 = !isCandidate || candidateEntity === "1099 Basis";

    // ----------------------------------------------
    // ⭐ FINAL ADJUSTMENT LOGIC
    // For 1099 → add (+adjustPlus + adjustMinus)
    // For W2 → use ADP deduction (negative)
    // ----------------------------------------------

    let adjValue = 0;

    if (isW2) {
      // W2 → only ADP deduction applies (negative)
      adjValue = -Math.abs(adpAmt);
    } else if (is1099) {
      // 1099 → adjustment = plus + minus
      // Note: adMinAmt is already negative (e.g. -0.62)
      adjValue = adPlusAmt + (-adMinAmt);
    }

    // ✔ Format adjustment: +X.XX or -X.XX or 0.00
    let adjDisplay = "";
    if (adjValue > 0) adjDisplay = "+" + adjValue.toFixed(2);
    else if (adjValue < 0) adjDisplay = adjValue.toFixed(2); // already negative
    else adjDisplay = "0.00";

    // NET CALCULATIONS
    const netW2 = (invAmt + adjValue).toFixed(2);
    const net1099 = (invAmt + adjValue).toFixed(2);

    return (
      <tr className="font-weight-bold">
        <th scope="row" colSpan={3} style={CUSTOM_REPORT_STYLES.totalCell}>Total</th>

        {/* Total Hours */}
        <td style={CUSTOM_REPORT_STYLES.totalCell}>{hrs}h {min}m</td>

        {/* Invoice Amount */}
        <td style={CUSTOM_REPORT_STYLES.totalCell}>{formatAmount(invAmt)}</td>

        {/* Adjustments */}
        <td style={CUSTOM_REPORT_STYLES.totalCell}>{formatAmount(adjDisplay)}</td>

        {/* Net Payable */}
        <td style={CUSTOM_REPORT_STYLES.totalCell}>{formatAmount(isW2 ? netW2 : net1099)}</td>

        {/* Paid Amount */}
        <td style={CUSTOM_REPORT_STYLES.totalCell}>{formatAmount(payAmt)}</td>
      </tr>
    );
  };




  const tmLogRptExportPDF = () => {
    const headers = [
      [
        "S.No.",
        "Year",
        "Month",
        "Total Hours",
        "Invoice Amount ($)",
        usrType === "candidate" && candidateEntity === "W2 Basis" ? "ADP(TAX) Adjustment" : "Adjustment",
        "Payment Amount ($)"
      ],
    ];
    let data = [];
    monthlyRpt.map((item, key) =>
      data.push([
        key + 1,
        item.year,
        months.filter((x) => x.id === item.month)[0].name,
        item.hours && parseFloat(item.hours).toFixed(2),
        item.totalAmount && parseFloat(item.totalAmount).toFixed(2),
        usrType === "candidate" && candidateEntity === "W2 Basis" ? item?.adpDeduction && "-" + parseFloat(item?.adpDeduction) :
          (item?.adjustPlus && "+" + parseFloat(item?.adjustPlus)) || (item?.adjustMinus > 0 && "-" + parseFloat(item?.adjustMinus)),
        item.paidAmount && parseFloat(item.paidAmount).toFixed(2),
      ])
    );
    setSelectedCol(headers);
    setSelectedColData(data);
    setPdfShowHide(true);
  };

  const handlepdfShowHide = () => {
    setPdfShowHide(false);
    setSelectedCol([]);
    setSelectedColData([]);
  };

  const getNetAmountWithAdjustment = (item) => {
    let netAmt = Number(item?.totalAmount) || 0;

    // Apply adjustments for non-candidates or 1099 candidates
    if (usrType !== "candidate" || candidateEntity === "1099 Basis") {
      if (item?.adjustPlus) netAmt += Number(item.adjustPlus);
      if (item?.adjustMinus) netAmt -= Number(item.adjustMinus);
    }

    // Candidate-specific deduction
    if (usrType === "candidate" && item?.adpDeduction) {
      netAmt -= Number(item.adpDeduction);
    }

    return netAmt.toFixed(2);
  };

  const getReportTitle = () => {
    if (candidateEntity === "1099 Basis") return "Compensation Reports";
    if (candidateEntity === "W2 Basis") return "Pay Reports";
    if (candidateEntity === "C2C Basis") return "Invoice Reports";
    return "Custom Reports";
  };

  const totalInvoiceAmount = monthlyRpt.reduce((sum, item) => sum + (Number(item.totalAmount) || 0), 0);
  const totalReceivedAmount = monthlyRpt.reduce((sum, item) => sum + (Number(item.paidAmount) || 0), 0);
  const totalNetAmount = monthlyRpt.reduce((sum, item) => sum + (Number(getNetAmountWithAdjustment(item)) || 0), 0);
  const totalHoursLabel = (() => {
    let totalHours = 0;
    let totalMinutes = 0;
    monthlyRpt.forEach((item) => {
      totalHours += Number(item.hours) || 0;
      totalMinutes += Number(item.minutes) || 0;
    });
    totalHours += Math.floor(totalMinutes / 60);
    totalMinutes = totalMinutes % 60;
    return `${totalHours}h ${totalMinutes}m`;
  })();


  return (
    <React.Fragment>
      <div className="mt-2">
        <style>{`
          .custom-excel-btn {
            display: inline-flex !important;
            align-items: center;
            gap: 8px;
            border-radius: 999px !important;
            border: 1px solid rgba(224, 231, 255, 1) !important;
            background: #eef2ff !important;
            color: #4338ca !important;
            padding: 7px 12px !important;
            font-size: 12px !important;
            font-weight: 700 !important;
            line-height: 1.5 !important;
          }

          .custom-report-table tbody tr:hover td {
            background-color: #f8fbff !important;
          }

          @media (max-width: 991.98px) {
            .custom-report-table {
              min-width: 980px;
            }
          }
        `}</style>
        <div className="card shadow-none border-1" style={CUSTOM_REPORT_STYLES.shell}>
          <div style={CUSTOM_REPORT_STYLES.hero}>
            <div style={CUSTOM_REPORT_STYLES.heroRow}>
              <div style={CUSTOM_REPORT_STYLES.heroCopy}>
                <div style={CUSTOM_REPORT_STYLES.titleRow}>
                  <span style={CUSTOM_REPORT_STYLES.titleIcon}>
                    <i className="fa fa-bar-chart" aria-hidden="true"></i>
                  </span>
                  <div style={CUSTOM_REPORT_STYLES.titleText}>
                    <h2 style={CUSTOM_REPORT_STYLES.title}>{getReportTitle()}</h2>
                    <p style={CUSTOM_REPORT_STYLES.subtitle}>
                      Review monthly amounts, adjustments, and payments in one place, then export the report to Excel or PDF when you are ready.
                    </p>
                  </div>
                </div>
              </div>
              <div style={CUSTOM_REPORT_STYLES.actionRow}>
                <ReactHTMLTableToExcel
                  id="tmLogTable"
                  className="btn btn-sm custom-excel-btn"
                  table="Invoice_Report"
                  filename="Invoice_Report"
                  sheet="Invoice_Report"
                  buttonText={<><i className="fa fa-file-excel-o" style={{ marginRight: "6px" }} /> Export to Excel</>}
                />
                <button
                  type="button"
                  className="btn btn-sm"
                  disabled={monthlyRpt.length === 0}
                  onClick={tmLogRptExportPDF}
                  style={CUSTOM_REPORT_STYLES.primaryButton}
                >
                  <i className="fa fa-print" aria-hidden="true"></i> Generate PDF
                </button>
              </div>
            </div>
          </div>
          <div style={CUSTOM_REPORT_STYLES.contentWrap}>
            <div style={CUSTOM_REPORT_STYLES.filterShell}>
              <div style={CUSTOM_REPORT_STYLES.filterGrid}>
                {usrType !== "candidate" && (
                  <div>
                    <label htmlFor="candidate" style={CUSTOM_REPORT_STYLES.filterLabel}>Candidate</label>
                    <select
                      name="candidate"
                      id="candidate"
                      className="form-control"
                      onChange={handleCandidateChange}
                      aria-label="Select Candidate"
                    >
                      <option value="">Select Candidate</option>
                      {candidateList.map((item) => (
                        <option key={item.performerid} value={item.performerid}>
                          {item.performername} {item.lastName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <label htmlFor="year" style={CUSTOM_REPORT_STYLES.filterLabel}>Year</label>
                  <select
                    name="year"
                    id="year"
                    className="form-control"
                    onChange={handleChangeYear}
                    value={selectedYear}
                    aria-label="Select Year"
                  >
                    <option value="">Select Year</option>
                    {years.filter(x => x.name <= (new Date().getFullYear())).map((item) => (
                      <option key={item.name} value={item.name}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div style={CUSTOM_REPORT_STYLES.statsGrid}>
            <div style={CUSTOM_REPORT_STYLES.statCard}>
              <p style={CUSTOM_REPORT_STYLES.statLabel}>Report Rows</p>
              <p style={CUSTOM_REPORT_STYLES.statValue}>{monthlyRpt.length}</p>
              <p style={CUSTOM_REPORT_STYLES.statMeta}>Monthly entries currently loaded in the report.</p>
            </div>
            <div style={CUSTOM_REPORT_STYLES.statCard}>
              <p style={CUSTOM_REPORT_STYLES.statLabel}>Total Hours</p>
              <p style={CUSTOM_REPORT_STYLES.statValue}>{totalHoursLabel}</p>
              <p style={CUSTOM_REPORT_STYLES.statMeta}>Combined work duration across the visible report rows.</p>
            </div>
            <div style={CUSTOM_REPORT_STYLES.statCard}>
              <p style={CUSTOM_REPORT_STYLES.statLabel}>Net Amount</p>
              <p style={CUSTOM_REPORT_STYLES.statValue}>{formatAmount(totalNetAmount.toFixed(2))}</p>
              <p style={CUSTOM_REPORT_STYLES.statMeta}>Invoice total after adjustments and deductions.</p>
            </div>
            <div style={CUSTOM_REPORT_STYLES.statCard}>
              <p style={CUSTOM_REPORT_STYLES.statLabel}>Received Amount</p>
              <p style={CUSTOM_REPORT_STYLES.statValue}>{formatAmount(totalReceivedAmount.toFixed(2))}</p>
              <p style={CUSTOM_REPORT_STYLES.statMeta}>
                Paid against {formatAmount(totalInvoiceAmount.toFixed(2))} in visible invoice amounts.
              </p>
            </div>
          </div>
          <div style={CUSTOM_REPORT_STYLES.contentWrap}>

            <h3 style={CUSTOM_REPORT_STYLES.sectionTitle}>Monthly Report Details</h3>
            <p style={CUSTOM_REPORT_STYLES.sectionSubtitle}>
              Track month-by-month hours, adjustments, net amount, and received payments from the current selection.
            </p>
            <div className="table-responsive" style={CUSTOM_REPORT_STYLES.tableShell}>
              <table
                id="Invoice_Report"
                className="table align-items-center table-hover mb-0 custom-report-table"
                style={CUSTOM_REPORT_STYLES.table}
              >
                <thead>
                  <tr>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}></th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Year</th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Month</th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Total Hours</th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Amount ($)</th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>
                      {usrType === "candidate" && candidateEntity === "W2 Basis"
                        ? "ADP (TAX) Adjustment"
                        : "Adjustment"}
                    </th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Net Amount ($)</th>
                    <th style={CUSTOM_REPORT_STYLES.tableHeadCell}>Received Amount ($)</th>
                  </tr>
                </thead>
                <tbody>
                  {monthlyRpt.length > 0 && monthlyRpt.map((item, index) => {
                    const monthName =
                      months.find((x) => x.id === item.month)?.name || "N/A";

                    const amount = Number(item.totalAmount).toFixed(2);
                    const paid = Number(item.paidAmount).toFixed(2);

                    const isCandidate = usrType === "candidate";
                    const isW2 = isCandidate && candidateEntity === "W2 Basis";
                    const is1099 = !isCandidate || candidateEntity === "1099 Basis";

                    let adjustmentText = "";

                    if (isW2 && item.adpDeduction) {
                      adjustmentText = `-${Number(item.adpDeduction).toFixed(2)}`;
                    } else if (is1099) {
                      if (item.adjustPlus) {
                        adjustmentText = `+${Number(item.adjustPlus).toFixed(2)}`;
                      } else if (item.adjustMinus) {
                        adjustmentText = `-${Number(item.adjustMinus).toFixed(2)}`;
                      }
                    }

                    return (
                      <tr key={`${item.year}-${item.month}-${index}`}>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{index + 1}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{item.year}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{monthName}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>
                          {item.hours}h {item.minutes}m
                        </td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{formatAmount(amount)}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{formatAmount(adjustmentText)}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{formatAmount(getNetAmountWithAdjustment(item))}</td>
                        <td style={CUSTOM_REPORT_STYLES.tableCell}>{formatAmount(paid)}</td>
                      </tr>
                    );
                  })}
                  {monthlyRpt.length > 0 && getTotalRows()}
                  {monthlyRpt.length === 0 && (
                    <tr>
                      <td colSpan={8} className="p-0 border-0">
                        <div style={CUSTOM_REPORT_STYLES.emptyState}>
                          <div style={CUSTOM_REPORT_STYLES.emptyIcon}>
                            <i className="fa fa-bar-chart" aria-hidden="true"></i>
                          </div>
                          <h4 style={CUSTOM_REPORT_STYLES.emptyTitle}>No report rows available</h4>
                          <p style={CUSTOM_REPORT_STYLES.emptyText}>
                            Select a candidate or year to load report data, or wait until monthly payment records are available for this account.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <GeneratePdf
        handlepdfShowHide={handlepdfShowHide}
        pdfShowHide={pdfShowHide}
        selectedCol={selectedCol}
        selectedColData={selectedColData}
      ></GeneratePdf>
    </React.Fragment>
  );
}

export default CustomReport;
